// API
// ----------------------------------------------------------------------

export const HOST_BASE_URL = process.env.REACT_APP_HOST_BASE_URL || '';

export const LIMIT = 1000;


